<template>
	<div
		class="ds-app-nav"
		@resize="boxResize"
	>
		<div
			class="scroll-arrow"
			@click="nextMenu"
		>
			<div class="btn">
				<i class="el-icon-arrow-left"></i>
			</div>
		</div>

		<div
			class="center-menu-box"
			id="nav-scroll-box"
		>
			<div class="scroll-warp">
				<div
					@click="goHome"
					class="menu-item"
					:class="!activeHistoryTabItem ? 'active-menu' : ''"
				>
					<div
						id="menu-item-home"
						class="menu-item-text"
					>
						<span>首页</span>
					</div>
				</div>
				<div
					v-for="item in historyTopTabMenuList"
					:key="item.id"
					:id="'menu-item' + item.name"
					class="menu-item"
					:class="
                        !!activeHistoryTabItem &&
                        item.name == activeHistoryTabItem.name
                            ? 'active-menu'
                            : ''
                    "
				>
					<div
						class="menu-item-text"
						@click="goHisRouter(item)"
					>
						<span v-text="item.meta.title"></span>
					</div>
					<div
						class="menu-close"
						@click="closeTab(item)"
					>
						<i class="el-icon-circle-close"></i>
					</div>
				</div>
			</div>
		</div>

		<div
			class="scroll-arrow"
			@click="preMenu"
		>
			<div class="btn">
				<i class="el-icon-arrow-right"></i>
			</div>
		</div>

		<div class="right-content">
			<el-dropdown
				@command="handleCommand"
				class="user-face"
			>
				<div style="overflow:hidden;width:40px;height:40px;background: #fff;display: flex;align-items: center;justify-content: center;border-radius: 50%;">
					<i class="el-icon-user-solid" style="font-size:30px;"></i>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="myapp">我的应用</el-dropdown-item>
					<el-dropdown-item command="editPass">修改密码</el-dropdown-item>
					<el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<div v-if="orgList.length>0&&showSelectOrg" style="padding-left:10px;">
				<el-select
					v-model="isSectOrg"
					placeholder="请选择"
				>
					<el-option
						v-for="item in orgList"
						:key="item.id"
						:label="item.deptName"
						:value="item.id"
					>
					</el-option>
				</el-select>

			</div>
		</div>
		<!-- 修改密码 -->
		<chgpwd ref="chgpwdRef"></chgpwd>
	</div>
</template>

<script>
var scrollObj = null;
var chaeckScrollTimer = null;
var scrollElement = null;
var reloadTimer = null;
import { fileViewUrl } from "../utils/http";
import BScroll from "@better-scroll/core";
import chgpwd from "./EditPass";
export default {
	components: { chgpwd },
	data() {
		return {
			fileViewUrl: fileViewUrl,
			nextItemIndex: 0,
		};
	},
	methods: {
		async handleCommand(command) {
			if (command == "loginOut") {
				this.$store.dispatch("app/changeMenuLoading", true);
				await this.$store.dispatch("upms/loginOut");

				setTimeout(() => {
					this.$store.dispatch("app/changeMenuLoading", false);
					this.$router.replace({
						name: "login",
					});
				}, 1000);
			} else if (command == "myapp") {
				this.$emit("appChangeShow");
			} else {
				this.$refs.chgpwdRef.open();
			}
		},

		goHome() {
			this.$router.replace({
				name: "home",
			});
			this.$store.dispatch("app/addHistoryTopTabMenu", null);
		},

		goHisRouter(item) {
			this.$router.replace({
				name: item.name,
			});
			this.$store.dispatch("app/addHistoryTopTabMenu", item);
		},
		closeTab(item) {
			//如果关闭的是其他界面，路由不做操作
			this.$store.dispatch("app/closeHistoryTOpMenu", item);
			if (this.activeHistoryTabItem) {
				if (item.name != this.activeHistoryTabItem.name) {
					this.$router.replace({
						name: this.activeHistoryTabItem.name,
					});
				}
			} else {
				this.$router.replace({
					name: "home",
				});
			}
		},
		preMenu() {
			var oldStyle = scrollElement.style.transform;
			chaeckScrollTimer = setInterval(() => {
				if (this.nextItemIndex == 0) {
					clearInterval(chaeckScrollTimer);
					chaeckScrollTimer = null;
					scrollObj.scrollToElement(
						document.getElementById("menu-item-home"),
						350
					);
				} else {
					this.nextItemIndex = this.nextItemIndex - 1;
					scrollObj.scrollToElement(
						document.getElementById(
							"menu-item" +
								this.historyTopTabMenuList[this.nextItemIndex]
									.name
						),
						350
					);
				}
				if (oldStyle != scrollElement.style.transform) {
					clearInterval(chaeckScrollTimer);
					chaeckScrollTimer = null;
				}
			}, 30);
		},
		nextMenu() {
			var oldStyle = scrollElement.style.transform;
			chaeckScrollTimer = setInterval(() => {
				if (
					this.nextItemIndex <
					this.historyTopTabMenuList.length - 1
				) {
					this.nextItemIndex = this.nextItemIndex + 1;
					scrollObj.scrollToElement(
						document.getElementById(
							"menu-item" +
								this.historyTopTabMenuList[this.nextItemIndex]
									.name
						),
						350
					);
				} else {
					clearInterval(chaeckScrollTimer);
					chaeckScrollTimer = null;
				}
				if (oldStyle != scrollElement.style.transform) {
					clearInterval(chaeckScrollTimer);
					chaeckScrollTimer = null;
				}
			}, 30);
		},
		initScroll() {
			scrollElement = document.querySelector(
				"#nav-scroll-box>.scroll-warp"
			);
			scrollObj = new BScroll(document.querySelector("#nav-scroll-box"), {
				scrollY: false,
				scrollX: true,
			});

			if (this.activeHistoryTabItem) {
				scrollObj.scrollToElement(
					document.getElementById(
						"menu-item" + this.activeHistoryTabItem.name
					),
					350
				);
			}
		},
		boxResize() {
			if (reloadTimer) {
				clearTimeout(reloadTimer);
				reloadTimer = null;
			}
			reloadTimer = setTimeout(() => {
				if (scrollObj) {
					scrollObj.refresh();
				}
			}, 30);
		},
	},
	watch: {
		historyTopTabMenuList() {
			if (reloadTimer) {
				clearTimeout(reloadTimer);
				reloadTimer = null;
			}
			reloadTimer = setTimeout(() => {
				if (scrollObj) {
					scrollObj.refresh();
				}
			}, 30);
		},
		activeHistoryTabItem(value) {
			if (value) {
				setTimeout(() => {
					for (
						var i = 0;
						i < this.historyTopTabMenuList.length;
						i++
					) {
						if (
							value.name == this.historyTopTabMenuList[i]["name"]
						) {
							this.nextItemIndex = i;
						}
					}
					//菜单跳转滚动
					scrollObj.scrollToElement(
						document.getElementById("menu-item" + value.name),
						500
					);
				}, 30);
			}
		},
	},
	computed: {
		historyTopTabMenuList() {
			return this.$store.state.app.historyTopTabMenuList.filter(
				(item) => item.path
			);
		},
		activeHistoryTabItem() {
			return this.$store.state.app.activeHistoryTabItem;
		},
		orgList() {
			return this.$store.state.app.appPublicOrg;
		},
		isSectOrg: {
			get() {
				return this.$store.state.app.isSectOrg;
			},
			set(val) {
				this.$store.dispatch("app/changeAppOrg",val);
			},
		},
		//是否显示公共组织选择
		showSelectOrg(){
			if((this.$route.fullPath).includes("logisticsSys")){
				return false;
			}else{
				return true;
			}
			
		}
	},
	mounted() {
		setTimeout(() => {
			this.initScroll();
		}, 30);
		if (this.$route.name != "home") {
			this.$store.dispatch("app/addHistoryTopTabMenu", {
				name: this.$route.name,
				meta: this.$route.meta,
				path: this.$route.path,
			});
		} else {
			this.$store.dispatch("app/addHistoryTopTabMenu", null);
		}
	},
};
</script>

<style lang="scss" scoped>
.ds-app-nav {
	display: flex;
	width: 100%;
	overflow: hidden;
	background: #212844;
	box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.56);
	position: relative;
	z-index: 100;
	align-items: center;
	.right-content {
		padding-right: 10px;
		color: #ffffff;
		display: flex;
		align-items: center;

		.user-face {
			margin-left: 30px;
			cursor: pointer;
		}
		.message {
			font-size: 30px;
		}
	}
	.scroll-arrow {
		cursor: pointer;
		width: 55px;
		height: 55px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 10px;
		opacity: 0;
		transition: all 350ms;
		margin-left: vw(10);
		margin-right: vw(10);
		.btn {
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;
		}
		i {
			font-size: 20px;
			color: #ffffff;
		}
	}
	.center-menu-box {
		flex: 1;
		overflow: hidden;
		display: flex;
		align-items: center;
		.scroll-warp {
			white-space: nowrap;
			display: flex;
		}
		.menu-item {
			position: relative;
			margin-top: 10px;
			.menu-close {
				position: absolute;
				right: 20px;
				bottom: 15px;
				z-index: 100;
				color: #ffffff;
				cursor: pointer;
			}
			.menu-item-text {
				background: none;
				display: flex;
				align-items: flex-end;
				color: #ffffff;
				border-top-left-radius: 10px;
				border-top-right-radius: 10px;
				transition: all 350ms;
				cursor: pointer;
				padding-top: 20px;
				padding-bottom: 15px;
				span {
					padding-left: 40px;
					padding-right: 40px;
					font-size: 14px;
					display: block;
					white-space: nowrap;
				}
			}
		}
		.active-menu {
			.menu-close {
				color: #212844;
			}
			.menu-item-text {
				background: #ffffff;
				span {
					color: #212844;
				}
			}
		}
	}
}
.ds-app-nav:hover {
	.scroll-arrow {
		opacity: 1;
	}
}
</style>